type ScaleStepsProps = {
	/** The three scales, in order ("Une tâche", "Une équipe", "Un territoire"). */
	items: string[];
	active: number;
	onSelect: (index: number) => void;
	/** Id of the heading that names the list. */
	labelledBy: string;
	className?: string;
};

/**
 * The scales of the pinned scene, from the task to the territory. Each one is a real
 * button that scrolls the scene to its beat; the current one carries
 * aria-current="step". Below them a thread fills with the scroll and carries a solar
 * tip, like a fiber of the field (decorative, hidden from assistive tech).
 * The section drives [data-steps-fill] (scaleX) and [data-steps-head] (xPercent).
 */
export function ScaleSteps({ items, active, onSelect, labelledBy, className = '' }: ScaleStepsProps) {
	return (
		<div data-steps className={className}>
			<ol aria-labelledby={labelledBy} className="grid grid-cols-3 gap-x-4">
				{items.map((item, index) => {
					const current = index === active;
					return (
						<li key={item}>
							<button
								type="button"
								aria-current={current ? 'step' : undefined}
								onClick={() => onSelect(index)}
								className={`flex min-h-11 w-full items-center text-left text-[15px] font-medium leading-tight tracking-[-0.01em] transition-colors duration-300 ease-expo ${
									current
										? 'text-graphite dark:text-mineral'
										: 'text-graphite-muted hover:text-graphite dark:text-dusk-muted dark:hover:text-mineral'
								}`}
							>
								{item}
							</button>
						</li>
					);
				})}
			</ol>
			<div aria-hidden className="relative mt-1.5 h-px bg-graphite/[0.14] dark:bg-mineral/[0.14]">
				<span data-steps-fill className="absolute -top-px left-0 h-[2px] w-full origin-left scale-x-0 rounded-full bg-forest dark:bg-sage" />
				<span data-steps-head className="absolute left-0 top-0 h-px w-full">
					<span className="absolute left-0 top-0 h-[7px] w-[7px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-solar ring-[3px] ring-mineral dark:ring-forest-night" />
				</span>
			</div>
		</div>
	);
}
